<script lang="ts">
    import AppContent from '@/components/AppContent.svelte';
    import AppHeader from '@/components/AppHeader.svelte';
    import AppShell from '@/components/AppShell.svelte';
    import type {BreadcrumbItemType, ActionButtonType, SectionLinkType} from "@/types/types";
    import type { Snippet } from 'svelte';
    import Debug from "@/components/Debug.svelte";
    import {Toaster} from "@/components/ui/sonner";
    import {meta} from "@/meta.svelte";
    interface Props {
        breadcrumbs?: BreadcrumbItemType[];
        children?: Snippet;
        actionbuttons?: ActionButtonType[];
        sectionLinks?: SectionLinkType[];
    }

    let { breadcrumbs = [], children, actionbuttons, sectionLinks = [] }: Props = $props();

</script>
<AppShell variant="header">
    <Toaster position="top-right" richColors closeButton />
    <AppHeader {breadcrumbs} {actionbuttons} {sectionLinks}/>
    <AppContent variant="header">
        {@render children?.()}
    </AppContent>
</AppShell>
